export const buildURLScheme = (htmlContent) => {
    console.log('I want to print by IPad!')
    console.log(htmlContent);
    const encodedReceiptBase64 = encodeURIComponent(htmlContent); 
    const urlStart = "starpassprnt://v1/print/nopreview?html=";
        //OR
        const back = window.location.href;
        const size = "&size=4";
        const urlEnd = "&back=" + back;
        const passprntURL = urlStart + encodedReceiptBase64 + size + urlEnd;
        const openDrawerURL = "starpassprnt://v1/print/nopreview?drawer=ahead&back="+back;
        window.location.replace(passprntURL);
        //window.top.close();
        //window.open(openDrawerURL, "");
        //OR
        //window.location.href = passprntURL;
        //OR
        //this.location.replace(passprntURL);
        //window.close();
        //window.setTimeout(function(){alert("delayed url " + window.location.href);}, 20000);
        //this might work to delay the alert long enough to get the URL but only in Safari
}